/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FileStreamUploadResp } from '../../models/file-stream-upload-resp';

export interface ApiFileFilestreamPost$Params {

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
}

export function apiFileFilestreamPost(http: HttpClient, rootUrl: string, params?: ApiFileFilestreamPost$Params, context?: HttpContext): Observable<StrictHttpResponse<FileStreamUploadResp>> {
  const rb = new RequestBuilder(rootUrl, apiFileFilestreamPost.PATH, 'post');
  if (params) {
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FileStreamUploadResp>;
    })
  );
}

apiFileFilestreamPost.PATH = '/api/file/filestream';
